import { ModuleSelection } from "./module-selection.model";

export class CompanyModule {
  CompanyId: number;
  ModuleId: number;
  TransactionFee: number;
  RefundCost: number;

  constructor(companyId: number, moduleSelection: ModuleSelection) {
    this.CompanyId = companyId;
    this.ModuleId = moduleSelection.ModuleId;
    this.TransactionFee = moduleSelection.TransactionFee;
    this.RefundCost = moduleSelection.RefundCost;
  }
}